import * as React from 'react';
import {FieldProps} from '../Field';

/**
 * The interface of the group object.
 */
export interface GroupObject {
  name: string;
  label: string;
  variant?: GroupVariant;
}

/**
 * The group variant.
 */
export enum GroupVariant {
  Default = 'default',
  Inline = 'inline',
}

/**
 * The props interface of the group.
 */
export interface GroupProps extends GroupObject {
  children(group: GroupObject):
    | React.ReactElement<FieldProps>
    | React.ReactElement<FieldProps>[];
}
